import {UpsellDialogEntryPoint} from '@Libraries/upsell-dialog.library';
import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';
import {ClickableDiv} from '@Components/clickable-div';
import {PremiumCrownChip} from '@Components/premium-crown-chip/premium-crown-chip';
import {openSocialAccountsUpsellDialog} from '@Libraries/social-media-account.library';
import styles from './more-accounts-upsell.module.scss';

export function MoreAccountsUpsell(): ReactElement<any> | null {
  return (
    <ClickableDiv
      className={styles.moreAccountsUpsell}
      onClick={(): void => {
        openSocialAccountsUpsellDialog(UpsellDialogEntryPoint.MORE_ACCOUNTS_BANNER);
      }}
    >
      <span className={styles.addAccountTile}>
        <Icon icon="icon-plus" type={IconType.NONE} size={IconSize.SIZE_ICON_16} className={styles.addAccountTileIcon} />
        <PremiumCrownChip />
      </span>
      <Text size={TextSize.MD} val={window.i18next.t('pmwjs_add_another_account')} className={styles.moreAccountsUpsellText} />
    </ClickableDiv>
  );
}
